var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"valueSpan",staticClass:"overview_graph_value"},[_vm._v("\n"+_vm._s(_vm.commify(_vm.value))),((typeof _vm.value === 'number'))?_c('span',[_vm._v(","),_c('span',{staticClass:"decimal"},[_vm._v(_vm._s(_vm.value.toFixed(2).split('.')[1]))]),_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.unit))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282fbf88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/part/ui/overview-graph-value.vue
// module id = null
// module chunks = 